import React from 'react';
import PropTypes from 'prop-types';
import Announcement from '../../../classes/announcement/announcement';

class ListView extends React.Component {
  constructor (props) {
    super(props);

    this.listRef = React.createRef();
  }

  getAnnouncementList () {
    const { dictionary, data, eventClickAnnouncement } = this.props;

    const ListItem = this.props.listItem;
    return (
        data && data.map((item, index) => {
          const data = new Announcement(item, dictionary);
          const rawData = item;

          return <ListItem
            key={item.get('id')}
            item={data}
            rawItem={rawData}
            eventClickAnnouncement={eventClickAnnouncement}
          />;
        })
    );
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    this.listRef.current && this.listRef.current.scrollTo && this.listRef.current.scrollTo(0, 0);
  }

  render () {
    return (
      <div className='list-view-announcement-wrp'>
        { this.props.isLoading &&
          (
            <div className='ajax-waiting-overlay'>
              <div className='radial-progress'>
                <div className='circle'>
                  <div className='fill' />
                </div>
              </div>
            </div>
          )
        }

        <div className='list-view-announcement' ref={this.listRef}>
          <div className='list'>
            { this.getAnnouncementList() }
          </div>
        </div>
      </div>
    );
  }
}

ListView.propTypes = {
  listItem: PropTypes.func.isRequired,
  domain: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,

  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  dealType: PropTypes.string.isRequired,
  realtyType: PropTypes.string.isRequired,

  dictionary: PropTypes.object.isRequired,
  eventClickAnnouncement: PropTypes.func.isRequired,
  onUpdateFilter: PropTypes.func
};
ListView.defaultProps = {};

export default ListView;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/ListView.jsx